<template>
  <div
    class="bet-ticker-cell"
  >
    <div
      v-if="!betCashoutDetails"
      class="bet-outcome"
    >
      <Icon
        :name="betOutcomeIcon"
      />
      <span>
        {{ betOutcomeText }}
      </span>
    </div>
    <Tooltip
      v-else
      :text="betCashoutDetails"
      :html-text="true"
      right
    >
      <div class="bet-outcome">
        <Icon
          :name="betOutcomeIcon"
        />
        <span>
          {{ betOutcomeText }}
        </span>
      </div>
    </Tooltip>
  </div>
</template>

<script>
import { format, zonedTimeToUtc } from 'date-fns-tz';
import { filter } from 'lodash';
import { ref, computed } from 'vue';
import Icon from '@/components/common/Icon';
import Tooltip from '@/components/common/Tooltip';

const formatDateTime = (dateTime) => {
  if (!dateTime) return '-';
  const formattedDate = format(zonedTimeToUtc(dateTime, 'UTC'), 'MM/dd/yyyy');
  const formattedTime = format(zonedTimeToUtc(dateTime, 'UTC'), 'hh:mm a');
  return `${formattedDate}, ${formattedTime}`;
};

export default {
  components: {
    Icon,
    Tooltip,
  },
  props: {
    bet: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const betOutcomeOptions = ref({
      WON: { text: 'Won', icon: 'trophy' },
      LOST: { text: 'Lost', icon: 'thumbs-down' },
      VOID: { text: 'Void', icon: 'credit-card-x' },
      NOT_YET_SETTLED: { text: 'Not yet settled', icon: '' },
      CANCELLED: { text: 'Cancelled', icon: 'x' },
      CASHOUT: { text: 'Cashout', icon: 'coins-hand' },
    });
    const defaultOutcome = { text: 'Unknown', icon: '' };

    const betOutcome = computed(() => betOutcomeOptions.value[props.bet.betOutcome] || defaultOutcome);

    const betCashoutDetails = computed(() => {
      if (props.bet.betOutcome === 'CASHOUT') {
        const betCashout = filter(props.bet.betActions, (action) => action.betActionType === 'CASHOUT');
        if (betCashout.length === 0) return null;
        return `Date & time: ${formatDateTime(betCashout[0].actionTime)} <br> Cash-out value: ${betCashout[0].cashoutAmount / 100} ${betCashout[0].currency}`;
      }
      return null;
    });
    const betOutcomeText = computed(() => betOutcome.value.text);
    const betOutcomeIcon = computed(() => betOutcome.value.icon);

    return {
      betOutcomeText,
      betOutcomeIcon,
      betCashoutDetails,
    };
  },
};
</script>

<style lang="scss" scoped>
.bet-outcome {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid $gray500;
  padding: 0px 6px; border-radius: 50px;
}
</style>
